// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ldMEDZNYoJhALX1gjMmBm {\n  display: flex;\n}\n\n._2hNydlTls2sbRvKBcqCs0S {\n  margin-right: var(--space-large);\n}\n\n._2hNydlTls2sbRvKBcqCs0S:last-child {\n  margin-right: 0;\n}\n\n._GIRz7nNHcTLoUdt3na6e {\n  max-width: 300px;\n  max-height: 300px;\n}\n\n@media (max-width: 767px) {\n  ._1ldMEDZNYoJhALX1gjMmBm {\n    flex-flow: column;\n  }\n\n  ._2hNydlTls2sbRvKBcqCs0S {\n    margin-right: 0;\n  }\n\n  ._GIRz7nNHcTLoUdt3na6e {\n    width: 200px;\n    height: 200px;\n    margin: 0 auto calc(var(--space-small) * 2);\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"skills": "_1ldMEDZNYoJhALX1gjMmBm",
	"column": "_2hNydlTls2sbRvKBcqCs0S",
	"ratio": "_GIRz7nNHcTLoUdt3na6e"
};
module.exports = exports;
